'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _class, _temp2;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styles = require('./styles');
var _wavfichacertaFichacertaIcons = require('@bit/wavfichacerta.fichacerta.icons.close');
var _wavfichacertaFichacertaIcons2 = _interopRequireDefault(_wavfichacertaFichacertaIcons);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ModalContainer = (_temp2 = _class = function (_PureComponent) {
  _inherits(ModalContainer, _PureComponent);
  function ModalContainer() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ModalContainer);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalContainer.__proto__ || Object.getPrototypeOf(ModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (ref) {
      _this.modal = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ModalContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_styles.StyledModal, {
        centered: this.props.centred,
        isOpen: this.props.isOpen,
        size: this.props.size,
        contentStyle: this.props.contentStyle,
        innerRef: this.getRef,
        toggle: this.props.closeModal
      }, _react2.default.createElement('div', null, _react2.default.createElement(_styles.StyledModalHeader, null, this.props.header), this.props.showCloseIcon && _react2.default.createElement(_styles.ModalClose, {
        onClick: this.props.onClose
      }, _react2.default.createElement(_wavfichacertaFichacertaIcons2.default, null))), this.props.children, _react2.default.createElement(_styles.StyledModalFooter, null, this.props.footer));
    }
  }]);
  return ModalContainer;
}(_react.PureComponent), _class.defaultProps = {
  contentStyle: {},
  size: 'md',
  closeModal: function closeModal() {},
  centred: true,
  showCloseIcon: true
}, _temp2);
exports.default = ModalContainer;